import { vModelText as _vModelText, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b080f1a")

_pushScopeId("data-v-2b080f1a")
const _hoisted_1 = { class: "position-relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      tabindex: _ctx.tabindex,
      type: "search",
      ref: "autocomplete",
      class: _ctx.inputClass,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.local = $event)),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
      autocomplete: "chrome-off"
    }, null, 42, ["tabindex"]), [
      [_vModelText, _ctx.local],
      [_directive_localizedPlaceholder, {key: _ctx.placeholderKey, value: _ctx.placeholderValue, prevText: _ctx.placeholderPrevText, afterText: _ctx.placeholderAfterText }]
    ])
  ]))
})